import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { APIURL, TZ } from "../../../Global";
import "simplebar-react/dist/simplebar.min.css";
function Features() {

    const [data, setData] = useState([])

    useEffect(() => {
        const tokenString = sessionStorage.getItem('usertoken');
        let str = tokenString.replace(/["]+/g, '')

        axios.get(`${APIURL}/api/v1/staff/special-feature/?requested_user=config_admin`, {
            headers: {
                "Authorization": 'Token ' + str
            }
        })
            .then(res => {
                if (res.status === 200) {
                    const datas = res.data.message
                    const formattedFeatures = datas.map(feature => ({
                        ...feature,
                        feature_name: feature.features__feature_name.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase()) // Capitalize words
                    }));
                    setData(formattedFeatures)
                }
            })
            .catch(err => { })
    }, []);

    return (
        <div >
            <div className="" style={{ marginBottom: "1%" }}>
                <div style={{ display:"flex", backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", textAlign: "left", padding: "1%", borderRadius: "5px 5px 0px 0px" }}>
                    <label className="col-11">Special Feautures</label>
                    <label>&nbsp;&nbsp;&nbsp;&nbsp;Price</label>
                </div>
                <div style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
                    {data?.length > 0 && data.map((item) => {
                        return (
                            <div style={{ display: "flex", padding: "1%", border: "0.4px solid gray" }}>
                                <div className="col-11"> {item.feature_name}</div>
                                <div> :&nbsp;&nbsp;&nbsp;{item.price}</div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    );
}
export default Features;
